import { createStyles, keyframes } from '@mantine/core'

export type StylesParams = {
  borderSize: number
  maxWidthPercent: number
}

export const rotate = keyframes({
  from: { width: '100%' },
  to: { width: '140%' },
})

export default createStyles(
  (_theme, { borderSize, maxWidthPercent }: StylesParams) => {
    return {
      root: {
        borderRadius: '50%',
        border: `${borderSize}px solid transparent`,
        ...(borderSize > 0 && {
          backgroundImage: `linear-gradient(143.34deg, #BA0711 9.97%, #FF676F 49.87%, #B2050F 89.78%)`,
        }),
        cursor: 'pointer',
        '&, *': {
          transition: 'all .3s ease !important',
        },
      },
      avatarRoot: {
        position: 'relative',
        borderRadius: 'inherit',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundImage: `linear-gradient(90deg, #E3BE52 0%, #FCE7A3 21.89%, #EDC255 50.25%, #FADB7D 79.29%, #E5BA47 93.5%)`,
        },
      },
      avatarImage: {
        position: 'relative',
        zIndex: 1,
        borderRadius: 'inherit',
        maxWidth: `${maxWidthPercent}%`,
        maxHeight: `${maxWidthPercent}%`,
      },
    }
  },
)
